export const formatCurrency = (amount: number | null | undefined): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "KES",
  }).format(amount || 0);
